import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { first, map } from 'rxjs/operators'
import { UserServiceResources as us } from 'se-resource-types'

import { UserDuplicateLookupParams } from '@se-po/shared-data-access-models'

import { UserServiceApiService } from './user-service-api.service'

@Injectable({
  providedIn: 'root'
})
export class UserDuplicateLookupService {

  constructor(
    private api: UserServiceApiService,
  ) { }

  public search(params: UserDuplicateLookupParams): Observable<us.UserDuplicateLookupResponse> {
    const url = 'v3/user_duplicate_lookups/search'

    return this.api.post<us.UserDuplicateLookupResponse>(url, params)
      .pipe(
        first(),
        map(response => response.result)
      )
  }
}
